import { action } from 'satcheljs';

export const removeEmail = action('removeEmail');
